<template lang="pug">
  .page.profile-page
    header.page__header.profile-page__header
      main-header

    .profile-page__notification
      operator-notification(:notification="notification")

    .profile-page__container
      aside.profile-page__aside
        side-nav(
          :sideNavData="sideNavData"
        )
      main.profile-page__main
        router-view

    footer.page__footer
      main-footer
</template>

<script>
import { mapActions } from "vuex";
import MainHeader from "../../components/main-header/main-header";
import MainFooter from "../../components/main-footer/main-footer";
import SideNav from "../../components/side-nav/side-nav.vue";
import OperatorNotification from "./components/operator-requests/components/operator-notification.vue";

export default {
  name: "OperatorPage",
  components: {
    OperatorNotification,
    SideNav,
    MainFooter,
    MainHeader,
  },
  data() {
    return {
      notification: [],
      sideNavData: [
        //        {
        //          path: "/operator/requests-contests",
        //          text: "Заявки по конкурсу Министерств"
        //        },
        /*{
          path: "/operator/requests-quota",
          text: "Заявки"
        },*/
        {
          path: "/operator/requests",
          text: "Заявки",
        },
        {
          path: "/operator/settings",
          text: "Настройки",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["getNotifications"]),
    onSync() {
      setInterval(() => {
        this.getNotifications().then((res) => {
          this.notification = res;
        });
      }, 1000 * 30);
    },
  },
  mounted() {
    this.onSync();
  },
};
</script>
